import { render, staticRenderFns } from "./MsSelectBox.vue?vue&type=template&id=57d34c1a"
import script from "./MsSelectBox.vue?vue&type=script&lang=js"
export * from "./MsSelectBox.vue?vue&type=script&lang=js"
import style0 from "./MsSelectBox.vue?vue&type=style&index=0&id=57d34c1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports